module.exports = __webpack_public_path__ + "static/media/p3s3.21bdd69e.jpg";